import fetch from '@giro/shared-utils/fetch.util';

export default async function patchApiTerminalsRegistrationsIdService(
  id,
  body: any = {}
) {
  return fetch(`terminals/registrations/${id}`, {
    method: 'PATCH',
    ms: 'PDV',
    auth: true,
    body: JSON.stringify(body),
  });
}
